export default __webpack_public_path__ + "static/media/gcal.dc7eac67.svg";